import { L2ChainId, TokenId, Wei } from '../../types'
import { useMemo } from 'react'
import { useWithdrawLimit } from '../../store/withdraw/hook'

export function useWithdrawLimitByToken(
  tokenId: TokenId,
): [Record<L2ChainId, Wei>, boolean] {
  const limit = useWithdrawLimit()
  return useMemo(() => {
    try {
      if (!tokenId) {
        throw new Error(`Unknown tokenId, tokenId: ${tokenId}`)
      }
      if (limit[tokenId] === undefined) {
        throw new Error(`Limit size is undefined`)
      }

      return [limit[tokenId], limit.pending]
    } catch (e) {
      console.warn(e?.message)
      return [{}, limit.pending]
    }
  }, [limit, tokenId])
}
